var lib_core = require("lib-core");

var LoadingWatchdogStatemachine = require("./loadingWatchdogStatemachine.js");
var LoadingWatchdogModel = require("./loadingWatchdogModel.js");

var LoadingWatchdogController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(LoadingWatchdogController, lib_core.Controller);

module.exports = LoadingWatchdogController;

LoadingWatchdogController.prototype.createModel = function () {
    return new LoadingWatchdogModel(this.configuration);
};

LoadingWatchdogController.prototype.createStateMachine = function () {
    return new LoadingWatchdogStatemachine(this.root, this.getModel());
};